var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-box"},[_c('div',{staticClass:"loadingText"},[_vm._v(_vm._s(_vm.loadingText))]),_c('i',{staticClass:"el-icon-loading"})])}
var staticRenderFns = []

export { render, staticRenderFns }